import React from 'react';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';
import CommonStrings from 'resources/common-strings';
import CommonValues from 'resources/common-values';
import HelpBox from 'components/generic/help/index';

export default CreateReactClass({
    displayName: 'NoComparisonPeriodsMessage',

    propTypes: {
        id: PropTypes.string.isRequired,
        className: PropTypes.string.isRequired,
        altMessageText: PropTypes.string,
        adjustOverflow: PropTypes.bool,
    },

    getDefaultProps() {
        return {
            adjustOverflow: false,
        };
    },

    getHelpText() {
        return (
            <div className="comparisons-no-periods-help-content" key="comparisons-no-periods-help-content">
                <p key="initial-text">{CommonStrings.noComparisonPeriodsMessage.helpPopup.helpText}</p>
            </div>
        );
    },

    render() {
        return (
            <div className={this.props.className + ' no-available-periods'}>
                {this.props.altMessageText
                    ? this.props.altMessageText
                    : CommonStrings.noComparisonPeriodsMessage.initialText}
                <HelpBox
                    id={'no-comparison-periods-help-' + this.props.id}
                    appLevelCssClassName=""
                    helpContentsRenderer={this.getHelpText}
                    moduleName={CommonValues.SectionIDs.comparisons}
                    helpLabel="comparisons-no-periods-help"
                    optionalText={CommonStrings.noComparisonPeriodsMessage.helpLinkText}
                    renderIcon={false}
                    adjustOverflow={this.props.adjustOverflow}
                />
            </div>
        );
    },
});
